export default {
  getDetail: state => state.detail,
  getPageInfo: state => state.pageInfo,
  getList: state => state.list,
  getCondition: state => state.condition
};
